import { Component, OnDestroy, OnInit } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { MessageType } from '../../../../model/message.model';
import { BehaviorDataService } from '../../../../service/behaviorData.service';
import { ResizeService } from '../../../../service/resize.service';
import { MessageComponent } from '../../../../shared/components/messages/message-component';

@Component({
    selector: 'app-play-break-message',
    templateUrl: 'play-break-message.component.html',
    imports: [MessageComponent, TranslateModule],
})
export class PlayBreakMessageComponent implements OnInit, OnDestroy {
    isInPlayBreak: boolean;
    subscriptions$: Subscription[] = [];
    public get messageType(): typeof MessageType {
        return MessageType;
    }

    constructor(
        private behaviorData: BehaviorDataService,
        private resizeService: ResizeService,
    ) {}

    ngOnInit(): void {
        this.subscriptions$.push(
            this.behaviorData.getIsInPlayBreak.subscribe((data) => {
                this.isInPlayBreak = data;
                this.resizeService.resizeCashier();
            }),
        );
    }
    ngOnDestroy() {
        this.subscriptions$.map((subscription) => subscription.unsubscribe());
    }
}
